import { useQuery } from "@tanstack/react-query";
import { getTicketAttributes } from "controller/api";
import { ApiErrorType, GetTicketAttributesInputProps } from "shared";
import { sentryLogger } from "utilz";

export const useGetTicketAttributes = ({
  attributeName,
}: GetTicketAttributesInputProps) => {
  return useQuery({
    queryKey: ["attributes", "ticket", attributeName],
    queryFn: () => getTicketAttributes({ attributeName }),
    enabled: attributeName ? true : false,
    onSuccess(data) {},
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getTicketAttributes",
      }),
  });
};
